import {Subscription} from "../../services/subscription-service";
import {SubscriptionTypeValues} from "../../api/generated/herds-licensing";

type VisibilityInput = {
    isRegistryMember: boolean,
    subscription?: Pick<Subscription, 'isExpired' | 'type'> | null,
    /** Whether a Creem subscription is active. `undefined` means the Creem status is not known (yet). */
    creemActive?: boolean,
};

/**
 * "Resume payment" is only offered to breeders who are billed directly (no registry member)
 * and who have no subscription at all, an expired one, or a local trial without active Creem subscription.
 * While the Creem status is unknown, the trial case is not offered to avoid flickering.
 */
export const canResumeCheckout = ({isRegistryMember, subscription, creemActive}: VisibilityInput): boolean => {
    if (isRegistryMember) {
        return false;
    }
    if (!subscription || subscription.isExpired) {
        return true;
    }
    return subscription.type === SubscriptionTypeValues.TRIAL && creemActive === false;
};
